import React, { Component } from "react";
import API, { API_SERVER } from '../../repository/api';


class ForgotPassword extends Component {
    //   constructor(props) {
    //     super(props);
    //   }

    state = {
        email: '',
        password: '',
        toggle_alert: false,
        isVoucher: false,
        voucher: '',
        alertMessage: '',
        tabIndex: 1,
        showPass: false,
        showResendPass: false,
        showNewPass: false,
        showResetSuccess: false,
        showResetFailed: false,
        loading: false,
        idUser: null,
        otp: '',
        minutes: 5,
        seconds: 0,
        newPass: '',
        newPass2: '',
        enableResend: false,
        alert: '',
        success: '',
    };


    toMMSS = (duration) => {
        var seconds = parseInt((duration / 1000) % 60),
            minutes = parseInt((duration / (1000 * 60)) % 60),
            hours = parseInt((duration / (1000 * 60 * 60)) % 24);

        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        return minutes + ":" + seconds;
    };

    onChange(state, e) {
        const stateCopy = this.state;
        stateCopy[state] = e.target.value;
        this.setState(stateCopy);
    }

    kirimEMail = e => {
        this.setState({ loading: true })

        API.get(`${API_SERVER}v1/user/forgot-password/${this.state.email}`).then((res) => {
            if (res.status === 200 && !res.data.error) {

                localStorage.setItem('otpSend', 1);
                this.setState({ showResendPass: true, idUser: res.data.result.id });
                this.clearAlert()
                // this.props.history.push(`/OTP/${res.data.result.id}`)
            } else {
                this.setState({ alert: res.data.result })
            }
            this.setState({ loading: false })
        });
    }

    lupaPassword() {
        this.setState({ showResendPass: false })
    }

    componentDidMount() {
        this.timer = setInterval(() => {
            const { seconds, minutes } = this.state
            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    localStorage.removeItem('otpSend');
                    clearInterval(this.timer)
                    this.setState({ enableResend: true })
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
        if (this.props.id && this.props.otp) {
            this.setState({
                idUser: this.props.id,
                otp: this.props.otp,
                showNewPass: true
            })
        }

        let otpCheck = localStorage.getItem('otpSend');
        if (otpCheck == 1) {
            this.setState({ showResendPass: true })
            this.clearAlert()
        }
    }

    submitResetPass = e => {
        if (this.state.newPass.length < 8 || this.state.newPass2.length < 8) {
            this.setState({ alert: "Password must be at least 8 characters" })
        }
        else if (this.state.newPass === '' || this.state.newPass2 === '') {
            this.setState({ alert: 'Password cannot be empty' })
        }
        else {
            if (this.state.newPass !== this.state.newPass2) {
                this.setState({ alert: 'Confirm the password you entered is different ' })
            }
            else {
                API.get(
                    `${API_SERVER}v1/user/reset-password/${this.state.idUser}/${this.state.otp}/${this.state.newPass}/${this.state.newPass2}/${new Date().getTime()}`
                ).then((res) => {
                    if (res.status === 200) {
                        if (res.data.error) {
                            this.setState({ alert: res.data.result, showNewPass: false, showResetFailed: true })
                        }
                        else {
                            this.setState({ success: res.data.result, showNewPass: false, showResetSuccess: true })
                        }
                    }
                });
            }
        }
    }

    clearAlert() {
        this.setState({
            alert: '',
            success: ''
        })
    }

    saveOTP = e => {
        if (this.state.otp === '') {
            this.setState({ alert: 'The OTP code cannot be empty' })
        }
        else {
            API.post(
                `${API_SERVER}v1/user/check-otp`,
                {
                    otp: this.state.otp
                }
            ).then((res) => {

                if (res.status === 200) {
                    if (res.data.error) {
                        this.setState({ alert: 'Incorrect OTP code. Please try again.' })
                    }
                    else {
                        localStorage.removeItem('otpSend');
                        this.setState({ showNewPass: true, showResendPass: false, idUser: res.data.result.user_id })
                        this.clearAlert()
                    }
                } else {
                    this.setState({ alert: 'Incorrect OTP code. Please try again.' })
                }
            });
        }
    }

    render() {
        const { showResendPass, showNewPass, showResetSuccess, showResetFailed } = this.state;
        const { minutes, seconds } = this.state
        return (
            <div style={{ background: "#fff", margin: 0 }}>

                <div className={showResendPass ? 'row' : 'hidden'}>
                    <div className="col-sm-12">
                        <img
                            src="newasset/resend.svg"
                            alt=""
                        />
                    </div>
                    <div className="col-sm-12">
                        <p className="fs-24"><b style={{ color: '#00478C' }}>We have sent the link and OTP code to your email.</b></p>
                        <p className="fs-16"><b>Please kindly check your email and enter the OTP code correctly.</b></p>
                    </div>
                    <div className="col-sm-12">
                        {
                            this.state.alert == ''
                                ? null
                                : <div style={{ color: '#F00', marginBottom: 20 }}>{this.state.alert}</div>
                        }
                        {
                            this.state.success == ''
                                ? null
                                : <div style={{ color: '#049404', marginBottom: 20 }}>{this.state.success}</div>
                        }
                        <div style={{ padding: '0px 20px' }}>
                            <b style={{ float: 'left', color: 'black' }}>OTP Code</b>
                            <div className="input-group mb-4 mt-5">
                                <input
                                    type="text"
                                    value={this.state.otp}
                                    className="form-control"
                                    style={{ marginTop: 8 }}
                                    placeholder="Enter the OTP code that was sent to your email"
                                    onChange={this.onChange.bind(this, "otp")}
                                    required
                                />
                            </div>
                            <div className="col-sm-12">
                                <p className="mt-5">
                                    {
                                        this.state.enableResend
                                            ? <a style={{ cursor: 'pointer', color: '#00478C' }} onClick={this.lupaPassword.bind(this)}>Resend OTP Code</a>
                                            : <a style={{ cursor: 'context-menu', color: '#888' }}>Resend OTP Code ( {minutes}:{seconds < 10 ? `0${seconds}` : seconds} )</a>
                                    }
                                </p>
                            </div>
                            <button onClick={this.saveOTP.bind(this)} className="btn btn-ideku col-12 shadow-2 b-r-3 f-16" style={{ height: 60 }}>
                                Continue
                            </button>
                        </div>
                    </div>
                </div>

                <div className={showResendPass || showNewPass || showResetSuccess || showResetFailed ? 'hidden' : 'row'} style={{ padding: '0px 20px' }}>
                    <div className="col-sm-3"></div>
                    <img
                        src="newasset/back.svg"
                        style={{ paddingTop: 18 }}
                        alt=""
                    />
                    <div className="col-sm-12 mb-3"><b style={{ float: 'left', color: '#00478C' }}>Insert Your Email</b></div>
                    <div className="col-sm-12">
                        {
                            this.state.alert == ''
                                ? null
                                : <div style={{ color: '#F00', marginBottom: 20 }}>{this.state.alert}</div>
                        }
                        {
                            this.state.success == ''
                                ? null
                                : <div style={{ color: '#049404', marginBottom: 20 }}>{this.state.success}</div>
                        }
                        <b style={{ float: 'left', color: 'black' }}>Email</b>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                style={{ marginTop: 8 }}
                                placeholder="Insert your email"
                                onChange={this.onChange.bind(this, "email")}
                                required
                            />
                        </div>
                        <button disabled={this.state.loading} className="btn btn-ideku col-12 shadow-2 mt-5 b-r-3 f-16" style={{ height: 60 }} onClick={this.kirimEMail.bind(this)}>
                            Continue
                        </button>
                    </div>
                </div>

                <div className={showNewPass ? 'row' : 'hidden'} style={{ padding: '0px 20px' }}>
                    <div className="col-sm-3"></div>
                    <div className="col-sm-12 f-18 mb-3"><b style={{ float: 'left', color: '#00478C', marginTop: 30 }}>Create New Password</b></div>
                    <div className="col-sm-12">
                        {
                            this.state.alert == ''
                                ? null
                                : <div style={{ color: '#F00', marginBottom: 20 }}>{this.state.alert}</div>
                        }
                        {
                            this.state.success == ''
                                ? null
                                : <div style={{ color: '#049404', marginBottom: 20 }}>{this.state.success}</div>
                        }
                        <b style={{ float: 'left', color: 'black' }}>New password</b>
                        <div className="input-group">
                            <input
                                type="password"
                                className="form-control"
                                style={{ marginTop: 8 }}
                                placeholder="Enter your new password"
                                onChange={this.onChange.bind(this, "newPass")}
                                required
                            />
                        </div>
                        <b style={{ float: 'left', color: 'black', marginTop: 20 }}>Re-enter new password</b>
                        <div className="input-group">
                            <input
                                type="password"
                                className="form-control"
                                style={{ marginTop: 8 }}
                                placeholder="Re-enter your new password"
                                onChange={this.onChange.bind(this, "newPass2")}
                                required
                            />
                        </div>
                        <button disabled={this.state.loading} className="btn btn-ideku col-12 shadow-2 mt-5 b-r-3 f-16" style={{ height: 60 }} onClick={this.submitResetPass.bind(this)}>
                            Change Password
                        </button>
                    </div>
                </div>


                <div className={showResetSuccess ? 'row' : 'hidden'} style={{ padding: '0px 20px' }}>
                    <div className="col-sm-3"></div>
                    <div className="col-sm-12" style={{ marginTop: 30 }}>
                        <p className="fs-24"><b style={{ color: '#00478C' }}>Password has been updated successfully, please return to the login page and log in with your new password.</b></p>
                    </div>
                </div>
                <div className={showResetFailed ? 'row' : 'hidden'} style={{ padding: '0px 20px' }}>
                    <div className="col-sm-3"></div>
                    <div className="col-sm-12" style={{ marginTop: 30 }}>
                        <p className="fs-24"><b style={{ color: '#d02c2c' }}>Failed to update password, please reset password again and make sure you enter the OTP code sent to your email.</b></p>
                    </div>
                </div>
            </div>
        );
    }
}

export default ForgotPassword;
